import { Expose } from 'class-transformer';
import { IsString, IsDefined, IsNotEmpty } from '@lgce/class-validator';

export class CreateTagDto {
    @Expose()
    public id!: string;

    @IsDefined()
    @IsString()
    @IsNotEmpty()
    @Expose()
    public label!: string;

    @IsDefined()
    @IsString()
    @IsNotEmpty()
    @Expose()
    public agencyId!: string;
}
